import React from 'react';
import Alert from '@material-ui/lab/Alert';

export default function NoRoutingRuleAlert () {
   
    return (
        <>                  
        <Alert icon={false} severity="info"> No routing rules.</Alert>
        </>

    )
}